/* eslint-disable react/jsx-props-no-spreading */
import {Switch, styled, Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {bool, func} from 'prop-types';

const IOSSwitch = styled(props => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({theme}) => ({
  width: 45,
  height: 23,
  padding: 0,
  overflow: 'visible',
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 1,
    transitionDuration: '300ms',
    color: import.meta.env.VITE_MAIN_COLOR,
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#fff',
      backgroundColor: import.meta.env.VITE_MAIN_COLOR,
      '& + .MuiSwitch-track': {
        border: `1px solid #B3BDD2`,
        height: 23,
        opacity: 1,
        backgroundColor: 'primary.main'
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: import.meta.env.VITE_MAIN_COLOR,
      border: '6px solid #fff'
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3
    }
  },
  '& .MuiSwitch-thumb': {
    color: 'white',
    border: `1px solid #B3BDD2`,
    boxSizing: 'border-box',
    marginTop: 2,
    marginLeft: 2,
    width: 19,
    height: 19
  },
  '& .MuiSwitch-track': {
    height: '100%',
    borderRadius: 45 / 2,
    border: `1px solid #B3BDD2`,
    backgroundColor: '#D6D6D6',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  },
  '& .MuiSwitch-input': {
    width: 55,
    height: 25,
    left: -5,
    top: -2
  }
}));

const CustomSwitch = ({onChange, checked, disabled = false, ...props}) => {
  return (
    <Grid container alignItems="center" flexWrap="nowrap">
      <div onClick={disabled ? null : onChange} onKeyUp={onChange} role="button" tabIndex={0} style={{cursor: disabled ? 'not-allowed' : 'pointer'}}>
        <IOSSwitch {...props} checked={checked} onChange={disabled ? undefined : onChange} disabled={disabled} />
      </div>
      <Typography color="#9AA7C3" fontSize={12} ml={1.5}>
        {checked ? 'Oui' : 'Non'}
      </Typography>
    </Grid>
  );
};

CustomSwitch.propTypes = {
  onChange: func.isRequired,
  checked: bool.isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  disabled: bool
};

export default CustomSwitch;
